import { defineMessages } from "../core"

export const help = defineMessages({
  en: {
    "help.title": "Guide",
    "help.description": "What the assistant can do, how to ask, and what has changed.",
    "help.loadFailed": "The guide could not be loaded.",
    "help.tabGuide": "Guide",
    "help.tabNew": "What's new",
    "help.contentsLabel": "Guide contents",
    "help.example1": "What can this assistant do, and what can it not do?",
    "help.example2": "How do I prepare for a meeting?",
    "help.example3": "What is the difference between Work IQ and Classic?",
    "help.askPlaceholder": "Ask about the assistant…",
    "help.askLabel": "Ask about the assistant",
    "help.ask": "Ask",
    "help.welcomeTitle": "New here?",
    "help.welcomeBodyBefore": "The guide explains what the assistant can and cannot do and how to phrase questions. Type ",
    "help.welcomeBodyAfter": " followed by a question to ask about the assistant itself.",
    "help.openGuide": "Open guide",
    "help.dismiss": "Dismiss",
  },
  de: {
    "help.title": "Anleitung",
    "help.description": "Was der Assistent kann, wie man fragt und was sich geändert hat.",
    "help.loadFailed": "Die Anleitung konnte nicht geladen werden.",
    "help.tabGuide": "Anleitung",
    "help.tabNew": "Neuigkeiten",
    "help.contentsLabel": "Inhalt der Anleitung",
    "help.example1": "Was kann dieser Assistent, und was kann er nicht?",
    "help.example2": "Wie bereite ich mich auf ein Meeting vor?",
    "help.example3": "Was ist der Unterschied zwischen Work IQ und Classic?",
    "help.askPlaceholder": "Frage zum Assistenten stellen…",
    "help.askLabel": "Frage zum Assistenten stellen",
    "help.ask": "Fragen",
    "help.welcomeTitle": "Neu hier?",
    "help.welcomeBodyBefore": "Die Anleitung erklärt, was der Assistent kann und was nicht und wie man Fragen formuliert. Gib ",
    "help.welcomeBodyAfter": " gefolgt von einer Frage ein, um etwas über den Assistenten selbst zu erfahren.",
    "help.openGuide": "Anleitung öffnen",
    "help.dismiss": "Schließen",
  },
})
